export default {
    path: '/modules/role_warehouse',
    // name: 'modules-roles',
    component: () => import('@/modules/role_warehouse/pages/index.vue'),
    children: [
        {
            path: 'list',
            component: () => import('@/modules/role_warehouse/pages/list.vue'),
            meta: {
                pageTitle: '仓库账号列表',
            }
        },
        {
            path: 'edit/:user_id?',
            component: () => import('@/modules/role_warehouse/pages/edit.vue'),
            meta: {
                pageTitle: '修改角色仓库',
                parent: '/modules/role_warehouse/list',
            }
        }
    ],
};
